/* eslint-disable ember/no-runloop */
/*
 ember/no-runloop rationale:
  afterRender is the one queue guaranteed to run only once the entire render
  pass, including ancestor templates, has committed to the DOM. That guarantee
  is what this component actually needs; a modifier's install hook fires as its
  own element attaches to its immediate parent, which isn't the same guarantee.
*/
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { scheduleOnce } from '@ember/runloop';

export default class Wormhole extends Component {
  // On first render, a destination rendered by an ancestor template (e.g.
  // #fab-destination, rendered by application.hbs) may not exist in the DOM
  // yet -- a route's own template and its ancestors' templates can commit in
  // the same initial render pass, so a plain getter evaluated during that
  // pass can run before the destination is actually attached. Deferring to
  // afterRender guarantees the full render (including ancestor templates)
  // has committed before we look for it.
  @tracked hasSettled = false;

  constructor(owner, args) {
    super(owner, args);
    scheduleOnce('afterRender', this, this.settle);
  }

  settle() {
    this.hasSettled = true;
  }

  // Falls back to Ember's test container when the real destination doesn't
  // exist -- i.e. any isolated component/integration test that doesn't
  // render the full app layout.
  get destinationEl() {
    if (!this.hasSettled) {
      return null;
    }
    return (
      document.getElementById(this.args.to) ??
      document.getElementById('ember-testing')
    );
  }
}
